const actionOptionsSetData = data => ({
  type: 'OPTIONS_SET_DATA', payload: data,
})

const updateURLs = url => ({
  type: 'UPDATE_URLS', payload: url,
})

export { actionOptionsSetData, updateURLs }
